import lightboxDestroy from "./lightbox-destroy";

export default function lightboxSafeDestroy() {
  if (!document.querySelector(".ce-gallery")) {
    lightboxDestroy();
  }
}
